
class Vector {
    
    constructor(x, y) {
        this.x = x;
        this.y = y;
    }
    
    setX(x) {
        this.x = x;
        return this;
    }

    setY(y) {
        this.y = y;
        return this;
    }

    getX() {
        return this.x;
    }

    getY() {
        return this.y;
    }
    
}

export default Vector
